import React from "react";
import MainLayout from "../../../hoc/main";
import {FormContainer, Grid, Input} from "../../../components";
import {connect} from "react-redux";
import {editCardReaderData, getCardReaderData,} from "../../../redux/modules/CardReader/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";

class CardReaderEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            UNUM: ""
        };
    }

    componentDidMount() {
        this.props.getCardReaderData(this.props.match.params.id);
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            name: np.cardReader.data.name,
            UNUM: np.cardReader.data.UNUM
        });
    }

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.editCardReaderData(this.props.match.params.id, this.state);
    }

    render() {
        if (this.props.cardReader?.success) return <Redirect to="/card-reader"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"name"}
                            label={"CardReader name"}
                            value={this.state.name}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <Input
                            name={"UNUM"}
                            label={"CardReader UNUM"}
                            value={this.state.UNUM}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    cardReader: state.cardReader,
});

const mapDispatchToProps = {
    editCardReaderData,
    getCardReaderData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(CardReaderEdit)
);
